"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourLocalNararaPlumber() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="80611" id="your-local-narara-plumber" className="dark bg-slate-950 text-white relative overflow-hidden py-24 lg:py-32 flex items-center justify-center min-h-[70vh]">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-900/20 via-slate-950 to-slate-950 z-0 pointer-events-none" />

      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none flex items-center justify-center mix-blend-screen">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581682/img/central_coast_coastline_watermark_dark.png" alt="" className="w-full h-full object-cover" aria-hidden="true" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center max-w-[800px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <h2 className="text-4xl font-extrabold mb-6 tracking-tight text-white drop-shadow-2xl !font-sans md:text-5xl lg:text-6xl">Your Local Central Coast Plumber</h2>
        
        <p className="text-lg md:text-xl text-blue-100/80 mb-10 leading-relaxed drop-shadow-sm font-sans">Cliff Hanger Plumbing provides reliable plumbing services from Narara and across the Central Coast. From urgent leaks to hot water installations and drainage issues, we deliver fast professional plumbing solutions you can trust.</p>
        
        <Button asChild size="lg" className="text-lg px-10 py-7 rounded-full shadow-[0_0_40px_rgba(37,99,235,0.4)] hover:shadow-[0_0_60px_rgba(37,99,235,0.6)] transition-all duration-300 hover:-translate-y-1 bg-blue-600 hover:bg-blue-500 text-white font-bold tracking-wide">
          <Link to="/ContactPage">Call 0417 818 188</Link>
        </Button>
      </div>
    </section>;
}